import MainHeaderStore from "../stores/MainHeaderStore";

interface Props {
  mainHeaderStore: MainHeaderStore;
}

const useMainHeader = ({ mainHeaderStore }: Props) => {
  const onSearchIconClick = () => {
    mainHeaderStore.setIsSearchMobOpen(true);
  };
  const onBurgerIconClick = () => {
    mainHeaderStore.setIsMenuMobOpen(!mainHeaderStore.isMenuMobOpen);
  };
  const onCartIconClick = () => {
    mainHeaderStore.setCartVisible(!mainHeaderStore.isCartVisible);
  };

  return { onSearchIconClick, onBurgerIconClick, onCartIconClick };
};

export default useMainHeader;
